import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./ClaimCelebration.css";

const CONFETTI_COLORS = [
  "#e8487f",
  "#9b6bff",
  "#5c7cfa",
  "#3dc7d9",
  "#ffd54a",
  "#ff8a5c",
  "#6bcf8e",
  "#f062d4",
];

/** Precomputed so each mount is stable (no hydration flicker in SSR-less CRA). */
const OUTER_PIECES = Array.from({ length: 20 }, (_, i) => ({
  i,
  angle: (i * 360) / 20,
  color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
  w: 6 + (i % 4) * 2,
  h: 8 + (i % 3) * 3,
  radius: 148 + (i % 5) * 8,
}));

const INNER_PIECES = Array.from({ length: 14 }, (_, i) => ({
  i,
  angle: (i * 360) / 14 + 12,
  color: CONFETTI_COLORS[(i + 3) % CONFETTI_COLORS.length],
  w: 5 + (i % 3) * 2,
  h: 7 + (i % 2) * 2,
  radius: 102 + (i % 4) * 6,
}));

const ClaimCelebration = ({ emoji, name, onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!name) return null;

  const title = `${name} on the way`;

  return createPortal(
    <div
      className="claim-celebration"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
    >
      <div className="claim-celebration-inner">
        <div className="claim-celebration-stage" aria-hidden>
          <div className="claim-celebration-orbit claim-celebration-orbit--outer">
            {OUTER_PIECES.map((p) => (
              <span
                key={`o-${p.i}`}
                className="claim-celebit"
                style={{
                  transform: `translate(-50%, -50%) rotate(${p.angle}deg) translateY(-${p.radius}px)`,
                  width: `${p.w}px`,
                  height: `${p.h}px`,
                  background: p.color,
                }}
              />
            ))}
          </div>
          <div className="claim-celebration-orbit claim-celebration-orbit--inner">
            {INNER_PIECES.map((p) => (
              <span
                key={`i-${p.i}`}
                className="claim-celebit claim-celebit--alt"
                style={{
                  transform: `translate(-50%, -50%) rotate(${p.angle}deg) translateY(-${p.radius}px)`,
                  width: `${p.w}px`,
                  height: `${p.h}px`,
                  background: p.color,
                }}
              />
            ))}
          </div>
          <div className="claim-celebration-emoji-wrap">
            <span className="claim-celebration-emoji">{emoji}</span>
          </div>
        </div>
        <p className="claim-celebration-title">{title}</p>
      </div>
    </div>,
    document.body
  );
};

export default ClaimCelebration;
